import { DonateButton, ProjectComponent } from 'ppp'

export class DonateButtonLoader extends ProjectComponent {
  render() {
    return <DonateButton
            additionalClass={ this.props.additionalClass }
            project={ this.state.project }
            status={ this.status }
    />
  }
}
